export const visit = (vm, at) => {
vm(require("foundations-components/lang/hu.lyaml"));
at({ "hu": { "placeholder": "placeholder" } });
};